import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
export const SALES_TEAM_SERVICE_TOKEN = new InjectionToken<SalesTeamServiceInterface>('token for sales team data');

export interface SalesTeamServiceInterface {
  salesTeamIdsToArrayOfSalesPeopleIds(salesTeamIds: string[]): void;
}

export const DEFAULT_CURRENCY_CODE_TOKEN = new InjectionToken<Observable<string>>('default currency code');
export const PIPELINE_SETTINGS_URL_TOKEN = new InjectionToken<Observable<string>>(
  'app specific pipeline settings page URL',
);
export const PIPELINE_SETTINGS_ACCESS_TOKEN = new InjectionToken<Observable<boolean>>(
  'app specific access check for pipeline settings page access',
);
export const PARTNER_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken('token for current partner id');
export const MARKET_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken('token for current market id');
export const HAS_ACCESS_TO_ALL_ACCOUNTS_IN_MARKET_TOKEN = new InjectionToken<Observable<boolean>>(
  'token for the logged in user',
);
export const PARTNER_OVERRIDE_CONFIG_TOKEN = new InjectionToken<Observable<boolean>>(
  'token for bypassing quantity restrictions',
);
